<div class="confirm-modal ig-modal spider-events-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">SAVE EVENTS</div>

    <h4>Pulled {{totalEvents}} event(s) in total</h4>
    <div #div class="info-body">
        <div *ngFor="let page of data.events">
            <p *ngIf="data.isTest" style="color: orange">This is test pulling, only the first few events are pulled.</p>
            <p>Pulled {{page.events.length}} event(s) from {{page.pageLink}}</p>
            <ig-list *ngIf="page.events.length">
                <div header>
                    <ig-list-column-header>
                        <div style="max-width:1px"><mat-checkbox style="vertical-align: middle" (change)="toggleAll()"
                                [checked]="true"></mat-checkbox></div>
                        <div>Image</div>
                        <div>Title</div>
                        <div>Owner</div>
                        <div>Time</div>
                        <div>Address</div>
                        <div>Description</div>
                        <div>Category</div>
                        <div>Ticket Url</div>
                        <div></div>
                    </ig-list-column-header>
                </div>
                <div body>
                    <ig-list-item *ngFor="let event of page.events">
                        <div content>
                            <div style="max-width:1px">
                                <mat-checkbox style="vertical-align: middle" [(ngModel)]="event.checked"></mat-checkbox>
                            </div>
                            <div>
                                <img class="block-image" height="80px" [src]="imageService.imageSource(event)" />
                            </div>
                            <div>
                                <a [href]="event.eventLink" target="_blank"
                                    matTooltip="click to see this event details">{{event.name}}</a>
                            </div>
                            <div>
                                <div *ngIf="!event.hostLink"></div>
                                <a *ngIf="event.hostLink" [href]="event.hostLink" target="_blank"
                                    matTooltip="click to see the event owner">{{event.owner.name}}</a>
                            </div>
                            <div style="display: block">
                                <div *ngFor="let time of event.eventTimes">
                                    {{time.startTimeFormatted}}{{time.endTimeFormatted?' - '+time.endTimeFormatted:''}}
                                </div>
                                <div *ngIf="!event.eventTimes || !event.eventTimes.length">
                                    <span style="color: orangered">Event past</span>
                                </div>
                            </div>
                            <div>
                                <span>{{event.address.address}}</span>
                            </div>
                            <div style="max-height: 150px; overflow:auto">
                                <span *ngIf="event.description">{{event.description}}</span>
                            </div>
                            <div>
                                <span *ngIf="event.category">{{event.category}}</span>
                            </div>
                            <div>
                                <a ticket *ngIf="event.ticketUri" [href]="event.ticketUri" target="_blank"
                                    matTooltip="click to go to the ticket website">{{event.ticketUri.length > 100 ?
                                    event.ticketUri.substr(0, 100)+'...' : event.ticketUri}}</a>
                            </div>
                            <div>
                                <div *ngIf="event.eventLink.includes('eventbrite.com')">
                                    <mat-icon *ngIf="event.isUpdated && !event.isUpdating"
                                        style="color:green;font-size: 28px">check</mat-icon>
                                    <mat-icon *ngIf="event.isUpdating" class="ig-spin"
                                        matTooltip="Fetching more event info..."
                                        style="color:deepskyblue;font-size: 28px;width: 28px;height: 28px;">autorenew</mat-icon>
                                </div>
                            </div>
                        </div>
                    </ig-list-item>
                </div>
            </ig-list>
        </div>
    </div>

    <div *ngIf="!data.isTest" class="flex action-row">
        <ig-button class="pointer m-l-3" color="cancel" (trigger)="close()">
            Cancel
        </ig-button>
        <ig-button *ngIf="totalEvents" class="pointer" size="md" [isAsync]="true" (trigger)="confirm($event)">
            Save
        </ig-button>
        <div *ngIf="totalEvents" save class="flex">
            <span class="m-r-3">Save these events as</span>
            <mat-radio-group class="radio-group" [(ngModel)]="isApproved">
                <div class="pdf-modal-panel version-wrap">
                    <div class="version">
                        <mat-radio-button [value]="true">
                            Approved
                        </mat-radio-button>
                        <mat-radio-button [value]="false" class="m-l-1">
                            Unapproved
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <span class="m-l-3">for
                <ig-drop-down ngClass="event-btn" [place]="'top'" showDropDownItem="true">
                    <ig-drop-down-trigger [text]="data.hubName||'-- Select --'">
                    </ig-drop-down-trigger>
                    <div items>
                        <ig-drop-down-item *ngFor="let account of data.accounts" (click)="setAccount(account.userName)">
                            {{account.userName}}
                        </ig-drop-down-item>
                    </div>
                </ig-drop-down>
            </span>
        </div>
    </div>
    <div *ngIf="data.socialName.includes('eventbrite') && (isFetchingMoreInfo || isSaving)">
        <hr>
        <div>
            <span *ngIf="isFetchingMoreInfo">Fetching more event info...</span>
            <span *ngIf="isSaving">Uploading event images to AWS...</span>
            <span><mat-icon class="ig-spin"
                    style="color:deepskyblue;font-size: 28px;width: 28px;height: 28px;position:relative;top:7px">autorenew</mat-icon>
            </span>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/add.spider.events.modal/add.spider.events.modal.component.html